<!--
* 组件名 : 页面Page组件
* 开发者 : LH
*
* 参数:
* background [Array, String]   option - 背景图信息, 可以为i18n字符串|i18n字符串数组|颜色值|i18n视频
* linkAbove  [Boolean]         option   - 是否与一屏连接 (只有第一张手绘图需要加这个)
* slideUpIn  [Boolean]         option   - 是否执行 slide up in 效果 (与 v-slide-up-in 结合使用)
-->

<template>
  <section class="v-page" :class="{ 'link-above': linkAbove }" v-bind="$attrs">
    <template v-if="background">
      <v-background :src="background" :slideUpIn="slideUpIn" />
      <section class="v-page-content">
        <slot />
      </section>
    </template>
    <template v-else><slot /></template>
  </section>
</template>

<script>
export default {
  name: "v-page",
  props: {
    background: [Array, String],
    linkAbove: {
      type: Boolean,
      default: false,
    },
    slideUpIn: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.v-page {
  min-height: 100vh;
  position: relative;

  .v-background {
    width: 100%;
    overflow: hidden;
  }
}
</style>
